// Zentrale API-Base Konfiguration
export const API_BASE = import.meta.env.VITE_API_BASE || '';
export const apiUrl = (path) => `${API_BASE}${path}`;

// Helper für häufige API-Calls
export const apiCall = async (path, options = {}) => {
  const url = apiUrl(path);
  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };
  
  return fetch(url, { ...defaultOptions, ...options });
};

// GET Helper
export const apiGet = (path, options = {}) => apiCall(path, { method: 'GET', ...options });

// POST Helper  
export const apiPost = (path, body, options = {}) => apiCall(path, {
  method: 'POST',
  body: JSON.stringify(body),
  ...options
});
